/// <reference types="vite/client" />
import { BROWSER, DEV, NODE } from 'esm-env';

// We have a lot of dependence on this. Should we instead depend directly on DEV? Convert one way
// or the other.
export const IsProduction = !DEV;

// https://stackoverflow.com/a/31090240/8107589

// const IsBrowser = new Function('try {return this===window;}catch(e){ return false;}');
// // eslint-disable-next-line @typescript-eslint/no-implied-eval, no-new-func
// const IsNode = new Function('try {return this===global;}catch(e){return false;}');
// TODO: Reconcile these with BROWSER/NODE.
export const IsBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const IsNode =
  typeof process !== 'undefined' && process.versions !== null && process.versions.node !== null;
export const isDebugContext = () => DEV || env().VSCODE_INSPECTOR_OPTIONS !== undefined;

// TODO: Consider some notion of SSR or gcloud environment.

function env(): Partial<Record<string, string>> {
  return IsNode ? process!.env : { ...import.meta.env };
}

const isProdForced = () => env().VITE_FORCE_PROD === 'TRUE';

export const Env = env();

export function isDevContext(forceProd?: boolean) {
  // console.log(
  //   `DEV:${DEV} BROWSER:${BROWSER} env:${toDebugJson(env)} import:${
  //     import.meta.env.VITE_FORCE_PROD as string
  //   }`
  // );
  forceProd ??= isProdForced();
  const isDev = DEV && !forceProd;
  // if (DEV) {
  //   console.log(
  //     `isDevContext=${isDev}, DEV=${DEV}, forceProd=${forceProd} viteForceProd=${env['VITE_FORCE_PROD']}`
  //   );
  // }
  return isDev;
}

export const EnvMode = [
  DEV ? 'D' : '',
  isDevContext() ? 'd' : '',
  BROWSER ? 'B' : '',
  IsBrowser ? 'b' : '',
  NODE ? 'N' : '',
  IsNode ? 'n' : '',
].join('');
